<template>
  <div>
    <!-- <div v-if="editable&&isWriting" class="alert alert-info alert-dismissible fade show cursor-pointer" 
      style="margin-bottom:13px !important; padding: 10px 3px !important" role="alert"
      v-on:click="setPermitData">
      <span class="q-pl-sm q-pr-md">
        <q-icon name="o_emoji_objects" size="sm" />
      </span>
      <q-chip dense color="teal" text-color="white">
        발급
      </q-chip>
      정보를 허가서에서 가져오기
    </div>
    <c-card title="작업 위험성평가">
      <template slot="card-detail">
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <c-field
              :disabled="!isWriting"
              :editable="editable"
              :data="workPermit"
              deptValue="assessWriteDeptCd"
              type="dept_user"
              label="발급"
              name="assessWriteUserId"
              v-model="workPermit.assessWriteUserId">
            </c-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <c-field
              :disabled="!isWriting"
              :editable="editable"
              :data="workPermit"
              deptValue="assessApprovalDeptCd"
              type="dept_user"
              label="승인"
              name="assessApprovalUserId"
              v-model="workPermit.assessApprovalUserId">
            </c-field>
          </div>
      </template>
    </c-card> -->
    <c-table
      ref="usertable"
      title="JSA 참가자"
      :key="tableKey"
      :columns="grid2.columns"
      :gridHeight="grid2.height"
      :data="workPermit.assessUsers"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&isWriting"
      selection="multiple"
      rowKey="sopWorkAssessUserId"
      @changeDataLength="changeDataLength"
    >
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable&&isWriting" label="추가(작업업체 근무자)" icon="add" :showLoading="false" @btnClicked="addVendorUser" />
          <c-btn v-if="editable&&isWriting" label="추가(현업)" icon="add" :showLoading="false" @btnClicked="addUser" />
          <c-btn v-if="editable&&isWriting" label="제외" icon="remove" :showLoading="false" @btnClicked="removeUser" />
        </q-btn-group>
      </template>
    </c-table>
    <c-table
      ref="table"
      class="q-mt-sm"
      title="안전조치사항"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="workPermit.assessments"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&isWriting"
      selection="multiple"
      rowKey="sopWorkSopAssessmentId"
      @table-data-change="tableDataChange"
    >
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable&&isWriting" label="추가" icon="add" :showLoading="false" @btnClicked="add" />
          <c-btn v-if="editable&&isWriting" label="제외" icon="remove" :showLoading="false" @btnClicked="remove" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
export default {
  name: 'swp-assessment',
  props: {
    workPermit: {
      type: Object,
      default: function() {
        return {
          sopWorkPermitId: '',  // 작업허가서 일련번호
          plantCd: '',  // 사업장 코드
          sopName: '',  // 작업명
          mdmSopId: '',  // 안전작업 표준 일련번호_SOP에서 불러와서 관련 정보 표시후 수정
          permitNo: '',  // 허가번호_(YYYYMMDD-01)
          swpStepCd: '',  // 진행단계 코드
          applicationDeptCd: '',  // 신청인 부서코드
          applicationDeptName: '',
          applicationUserId: '',  // 신청인 ID
          applicationUserName: '',
          permitTypeCd: '',  // 허가서 구분_화기/일반
          permitDate: '',  // 허가일
          workStartTime: '', // 작업시작시간
          workEndTime: '', // 작업종료시간
          workTime: [], // 작업시간
          processCd: '',  // 작업공정
          workLocation: '',  // 작업장소
          equipmentCd: '',  // 설비번호_설비마스터
          workSummary: '',  // 작업개요
          specialRequirements: '',  // 특별요구사항
          maintenanceDeptCheckUserId: '',  // 정비부서 책임자 - 안전조치확인
          maintenanceDeptEntryUserId: '',  // 정비부서 입회자 - 안전조치확인
          workCompleteTime: '',  // 작업완료시간
          workCompleteEntryUserId: '',  // 작업완료 입회자/확인자
          workCompleteWorkUserId: '',  // 작업완료 작업자
          issuedDeptCd: '',  // 발급자 부서코드
          issuedUserId: '',  // 발급자 ID
          approvalDeptCd: '',  // 승인자 부서코드
          approvalUserId: '',  // 승인자 ID
          relationCooperation1DeptCd: '',  // 관련부서 협조자1 부서코드
          relationCooperation1UserId: '',  // 관련부서 협조자1 ID
          relationCooperation2DeptCd: '',  // 관련부서 협조자2 부서코드
          relationCooperation2UserId: '',  // 관련부서 협조자2 ID
          vendorCd: '',  // 작업업체 코드
          overWorkFlag: '',  // 연장작업 여부
          psmFlag: 'N',  // PSM 관련 여부
          sopMocId: '',  // MOC 일련번호
          assessWriteUserId: '',  // 작업위험성평가_작성자 ID
          assessApprovalUserId: '',  // 작업위험성평가_승인자 ID
          regUserId: '',  // 등록자 ID
          chgUserId: '',  // 수정자 ID
          supWorks: [],
          deleteSupWorks: [],
          checkResults: [],
          gases: [],
          gasChecks: [], // 저장용
          gasCheckVals: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          maps: [],
          deleteMaps: [],
          workers: [],
          deleteWorkers: [],
          assessments: [],
          deleteAssessments: [],
          overs: [],
          deleteOvers: [],
          protectiveGears: [],
          deleteProtectiveGears: [],
          assessUsers: [],
          deleteAssessUsers: [],
        }
      }
    },
    isWriting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'jobStepName',
            field: 'jobStepName',
            label: '작업단계',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '잠재위험요소',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'before',
            field: 'before',
            label: '개선전',
            align: 'center',
            child: [
              {
                name: 'beforeFrequency',
                field: 'beforeFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'number',
              },
              {
                name: 'beforeStrength',
                field: 'beforeStrength',
                label: '강도',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'number',
              },
              {
                name: 'beforeRisk',
                field: 'beforeRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
              },
            ]
          },
          {
            name: 'safetyActionMeasures',
            field: 'safetyActionMeasures',
            label: '개선대책<br/>(위험성 12점 이상은 필수 개선)',
            align: 'left',
            type: 'text',
            value: '',
            setHeader: true,
            sortable: false,
          },
          {
            name: 'after',
            field: 'after',
            label: '개선후',
            align: 'center',
            child: [
              {
                name: 'afterFrequency',
                field: 'afterFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'number',
              },
              {
                name: 'afterStrength',
                field: 'afterStrength',
                label: '강도',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'number',
              },
              {
                name: 'afterRisk',
                field: 'afterRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
              },
            ]
          },
          {
            name: 'actionEducationFlag',
            field: 'actionEducationFlag',
            label: '조치/교육완료여부',
            align: 'center',
            type: 'check',
            'true': 'Y',
            'false': 'N',
            value: 'N',
            setHeader: true,
            sortable: false,
          },
        ],
        data: [],
        height: '400px'
      },
      grid2: {
        columns: [
          {
            name: 'vendorDeptName',
            field: 'vendorDeptName',
            label: '소속',
            align: 'center',
            sortable: false,
          },
          {
            name: 'userName',
            field: 'userName',
            label: '참가자',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
        height: '250px'
      },
      tableKey: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      // list setting
    },
    addVendorUser() {
      this.popupOptions.title = '도급업체 근무자'; // 도급업체 근무자
      this.popupOptions.param = {
        type: 'multiple',
        vendorCd: this.workPermit.vendorCd // 도급업체코드
      };
      this.popupOptions.target = () => import(`${'@/pages/common/vendor/vendorUserPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeVendorUserPopup;
    },
    closeVendorUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (!this.workPermit.assessUsers) this.workPermit.assessUsers = []
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.workPermit.assessUsers, { vendorUserCd: item.vendorUserCd }) === -1) {
            this.workPermit.assessUsers.push({
              sopWorkAssessUserId: uid(),  // JSA 참가자 번호
              sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
              vendorDeptName: item.vendorName,
              deptName: '',  // 담당/관련 부서
              vendorName: item.vendorName,  // 업체명
              vendorUserCd: item.vendorUserCd,  // 업체 참가자id
              userId: '',  // 참가자 id
              userName: item.personName,  // 참가자명
              regUserId: this.$store.getters.user.userId,  // 등록자 ID
              editFlag: 'C'
            })
            
            if (this.workPermit.permitTypeCd === 'SPT0000005'
              && this.$_.findIndex(this.workPermit.workers, { vendorUserCd: item.vendorUserCd }) === -1) {
              /**
               * 밀폐허가서인 경우
               * JSA 참가자와 동일하게 유지
               */
              let idx = this.$_.findIndex(this.workPermit.workers, { vendorCd: item.vendorCd })
              idx = idx > -1 ? idx : 0;
              this.workPermit.workers.splice(idx, 0, {
                sopWorkerId: uid(),  // 안전작업허가서_작업자 일련번호
                sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                belongName: '(협력업체) ' + item.vendorName,  // 소속명
                vendorCd: item.vendorCd,  // 작업업체 코드
                deptCd: '',  // 부서코드
                vendorUserCd: item.vendorUserCd,  // 직원 일련번호
                userId: '',  // 사용자id (현업인 경우)
                workerName: item.personName,  // 작업자명
                jobName: item.jobName,
                birthDate: item.birthDate,
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                chgUserId: '',  // 수정자 ID
                editFlag: 'C',
              })
            }
          }
        })
      }
    },
    addUser() {
      this.popupOptions.title = '사용자 검색';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.workPermit.plantCd
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (!this.workPermit.assessUsers) this.workPermit.assessUsers = []
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.workPermit.assessUsers, { userId: item.userId }) === -1) {
            this.workPermit.assessUsers.push({
              sopWorkAssessUserId: uid(),  // JSA 참가자 번호
              sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
              vendorDeptName: item.deptName,
              deptName: item.deptName,  // 담당/관련 부서
              vendorName: '',  // 업체명
              vendorUserCd: '',  // 업체 참가자id
              userId: item.userId,  // 참가자 id
              userName: item.userName,  // 참가자명
              regUserId: this.$store.getters.user.userId,  // 등록자 ID
              editFlag: 'C'
            })
            
            if (this.workPermit.permitTypeCd === 'SPT0000005'
              && this.$_.findIndex(this.workPermit.workers, { userId: item.userId }) === -1) {
              /**
               * 밀폐허가서인 경우
               * JSA 참가자와 동일하게 유지
               */
              let idx = this.$_.findIndex(this.workPermit.workers, { deptCd: item.deptCd })
              idx = idx > -1 ? idx : 0;
              this.workPermit.workers.splice(idx, 0, {
                sopWorkerId: uid(),  // 안전작업허가서_작업자 일련번호
                sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                belongName: '(현업) ' + item.deptName,  // 소속명
                vendorCd:'',  // 작업업체 코드
                deptCd: item.deptCd,  // 부서코드
                vendorUserCd: '',  // 직원 일련번호
                userId: item.userId,  // 사용자id (현업인 경우)
                workerName: item.userName,  // 작업자명
                jobName: item.jobName,
                birthDate: item.birthDate,
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                chgUserId: '',  // 수정자 ID
                editFlag: 'C',
              })
            }
          }
        })
      }
    },
    removeUser() {
      let selectData = this.$refs['usertable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.workPermit.deleteWorkers) this.workPermit.deleteWorkers = [];
        if (!this.workPermit.deleteAssessUsers) this.workPermit.deleteAssessUsers = [];
        this.$_.forEach(selectData, item => {
          if (this.workPermit.permitTypeCd === 'SPT0000005') {
            let workerIdx = this.$_.findIndex(this.workPermit.workers, assessUser => {
              return ((Boolean(assessUser.vendorUserCd) && assessUser.vendorUserCd === item.vendorUserCd) 
                || (Boolean(assessUser.userId) && assessUser.userId === item.userId))
            })
            let workerDeleteIdx = this.$_.findIndex(this.workPermit.deleteWorkers, deleteAssessUser => {
              return (Boolean(deleteAssessUser.vendorUserCd) && deleteAssessUser.vendorUserCd === item.vendorUserCd) 
                || (Boolean(deleteAssessUser.userId) && deleteAssessUser.userId === item.userId)
            })
            if (workerDeleteIdx === -1 && this.workPermit.workers[workerIdx].editFlag !== 'C') {
              this.workPermit.deleteWorkers.push(this.workPermit.workers[workerIdx])
            }
            this.workPermit.workers = this.$_.reject(this.workPermit.workers, this.workPermit.workers[workerIdx]);
          }

          if (this.$_.findIndex(this.workPermit.deleteAssessUsers, { sopWorkAssessUserId: item.sopWorkAssessUserId }) === -1
            && item.editFlag !== 'C') {
            this.workPermit.deleteAssessUsers.push(item)
          }
          this.workPermit.assessUsers = this.$_.reject(this.workPermit.assessUsers, item);
        })
        this.$refs['usertable'].$refs['compo-table'].clearSelection();
      }
    },
    add() {
      if (!this.workPermit.assessments) this.workPermit.assessments = [];
      this.workPermit.assessments.push({
        sopWorkSopAssessmentId: uid(),  // 작업허가서_작업위험성평가_일련번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
        jobStepName: '',  // 작업단계 명
        riskHazardName: '',  // 유해위험요인명
        safetyActionMeasures: '',  // 안전조치사항
        actionEducationFlag: 'N',  // 조치/교육완료여부
        beforeFrequency: null,  // 개선전 빈도
        beforeStrength: null,  // 개선전 강도
        beforeRisk: null,  // 개선전 위험도
        afterFrequency: null,  // 개선후 빈도
        afterStrength: null,  // 개선후 강도
        afterRisk: null,  // 개선후 위험도
        regUserId: this.$store.getters.user.userId,  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        editFlag: 'C'
      });
    },
    remove() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '제외할 행을 지정하세요.', // 제외할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.workPermit.deleteAssessments) this.workPermit.deleteAssessments = [];
        this.$_.forEach(selectData, item => {
          if (item.editFlag !== 'C'
            && this.$_.findIndex(this.workPermit.deleteAssessments, { sopWorkSopAssessmentId: item.sopWorkSopAssessmentId }) === -1) {
            this.workPermit.deleteAssessments.push(item)
          }
          this.workPermit.assessments = this.$_.reject(this.workPermit.assessments, item);
        });
        this.$refs['table'].$refs['compo-table'].clearSelection();
      }
    },
    setPermitData() {
      this.workPermit.assessWriteDeptCd = this.$_.clone(this.workPermit.issuedDeptCd)
      this.workPermit.assessWriteUserId = this.$_.clone(this.workPermit.issuedUserId)
      this.workPermit.assessApprovalDeptCd = this.$_.clone(this.workPermit.approvalDeptCd)
      this.workPermit.assessApprovalUserId = this.$_.clone(this.workPermit.approvalUserId)
    },
    tableDataChange(props, col) {
      if (!props.row[col.name]) return;
      if (col.name === 'beforeFrequency' || col.name === 'beforeStrength') {
        let c = this.checkFive(col.name, props.row['beforeFrequency'], props.row['beforeStrength']);
        if (c.bool) {
          let f = props.row['beforeFrequency'] ? Number(props.row['beforeFrequency']) : 0
          let s = props.row['beforeStrength'] ? Number(props.row['beforeStrength']) : 0
          this.$set(props.row, 'beforeRisk', (f * s))
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '1 ~ 5 사이로 지정해주세요.', // 제외할 행을 지정하세요.
            type: 'warning', // success / info / warning / error
          });
          this.$set(props.row, (c.type === 'f' ? 'beforeFrequency' : 'beforeStrength'), 0)
        }
      } else if (col.name === 'afterFrequency' || col.name === 'afterStrength') {
        let c = this.checkFive(col.name, props.row['afterFrequency'], props.row['afterStrength'])
        if (c.bool) {
          let f = props.row['afterFrequency'] ? Number(props.row['afterFrequency']) : 0
          let s = props.row['afterStrength'] ? Number(props.row['afterStrength']) : 0
          this.$set(props.row, 'afterRisk', (f * s))
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '1 ~ 5 사이로 지정해주세요.', // 제외할 행을 지정하세요.
            type: 'warning', // success / info / warning / error
          });
          this.$set(props.row, (c.type === 'f' ? 'afterFrequency' : 'afterStrength'), 0)
        }
      }
    },
    checkFive(colName, f, s) {
      if (colName.indexOf('Frequency') > -1) {
        if (f && f >= 0 && f <= 5) {
          return {
            bool: true
          };
        } else {
          return {
            bool: false,
            type: 'f',
          };
        }
      } else if (colName.indexOf('Strength') > -1) {
        if (s && s >= 0 && s <= 5) {
          return {
            bool: true
          };
        } else {
          return {
            bool: false,
            type: 's',
          };
        }
      }
    },
    changeDataLength() {
      this.tableKey = uid();
    },
  }
};
</script>
